import { Check } from 'lucide-react'
import { Button } from '../common/primitives/Button'
import styles from './Patterns.module.css'

export function Stepper({ steps = [], currentStep, onStepChange, backAction, continueAction, onBack, onContinue, backLabel = 'Back', continueLabel = 'Continue', canContinue = true, label = 'Workflow progress', className = '' }) {
  const currentIndex = steps.findIndex((step) => (step.value ?? step.key) === currentStep)
  const current = steps[currentIndex]
  const resolvedBackAction = backAction || (onBack ? <Button variant="secondary" onClick={onBack}>{backLabel}</Button> : null)
  const resolvedContinueAction = continueAction || (onContinue ? <Button onClick={onContinue} disabled={!canContinue}>{continueLabel}</Button> : null)
  return (
    <div className={`${styles.stepper} ${className}`.trim()}>
      <ol className={styles.stepList} aria-label={label} style={{ '--wf-step-count': steps.length }}>
        {steps.map((step, index) => {
          const value = step.value ?? step.key
          const complete = step.complete ?? index < currentIndex
          const selected = value === currentStep
          return (
            <li key={value} className={styles.stepItem}>
              <button type="button" className={`${styles.stepButton} ${selected ? styles.stepCurrent : ''} ${complete ? styles.stepComplete : ''}`.trim()} aria-current={selected ? 'step' : undefined} disabled={step.disabled || (!onStepChange && !complete && !selected)} onClick={() => onStepChange?.(value)}>
                <span className={styles.stepNumber}>{complete ? <Check size={14} aria-hidden="true" /> : index + 1}</span>
                <span className={styles.stepCopy}><span className={styles.stepMeta}>{complete ? 'Complete' : selected ? 'Current step' : 'Upcoming'}</span><span className={styles.stepLabel}>{step.label}</span></span>
              </button>
            </li>
          )
        })}
      </ol>
      <label className={styles.mobileStep}>
        <span className={styles.stepMeta}>Step {currentIndex + 1} of {steps.length}</span>
        <select
          className={styles.mobileStepSelect}
          aria-label={`${current?.label}, step ${currentIndex + 1} of ${steps.length}`}
          value={currentStep}
          onChange={(event) => onStepChange?.(event.target.value)}
          disabled={!onStepChange}
        >
          {steps.map((step) => {
            const value = step.value ?? step.key
            return <option key={value} value={value} disabled={step.disabled}>{step.label}</option>
          })}
        </select>
      </label>
      {(resolvedBackAction || resolvedContinueAction) ? <div className={styles.stepActions}>{resolvedBackAction}{resolvedContinueAction}</div> : null}
    </div>
  )
}
